// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { app } from '../../../../app';
import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';
import { resolve } from '../../../../init/store';

app.factory('ComputerAdministrationAccountShare', modal);

/** @ngInject */
function modal($uibModal) {

    return function (account) {

        return $uibModal.open({
            templateUrl: require('./computer-administration-accounts-share.html'),
            controller: controller,
            controllerAs: 'vm',
        }).result;

        /** @ngInject */
        function controller(
            $rootScope,
            $scope,
            $state,
            $translate,
            $uibModalInstance,
            CompanyUser,
            ConfirmDeleteModal,
            SharedAccountsService,
        ) {
            this.cancel = () => $uibModalInstance.dismiss();
            this.close = () => $uibModalInstance.close();
            $scope.account = account;
            const companyId = $state.params.companyId;
            
            $scope.st = new SmartTable();

            $scope.stGroup = new SmartTable();

            
            $scope.selectedGroup = 0;
            
            
            var errorInitGroupsAndUsers = function(error){
                //TODO handle error on user populate request
                $scope.spAlert = new SpAlert('danger', error.data.message);
            }
            
            var errorUnshareGroup = function(error){
                $scope.spAlert = new SpAlert('danger', error.data.message);
            }
            
            $scope.unshare = function(groupId){
                $scope.groupId = groupId;
                ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
                    .then(() => $scope.deleteConfirmed());
            }
            
            $scope.deleteConfirmed = function(){
                var param = {
                        companyId : companyId,
                        id : account.id,
                        groupId : $scope.groupId
                }
                SharedAccountsService.unshareCompanyServiceAccountsWithGroup(param, {}, function(response){
                    initGroupsAndUsers();
                    $scope.spAlert = new SpAlert('success', 'shared_accounts.messages.unshare_account');
                   
                }, errorUnshareGroup);
            }
            
            $scope.selectUser = function(position){
                
            }
            
            $scope.unselectUser = function(position){
                
            }


            $scope.shareWithSelectedGroup = function() {
                var param = {
                        companyId : companyId,
                        id : account.id,
                        groupId : $scope.selectedGroup
                }
                SharedAccountsService.shareCompanyServiceAccountsWithGroup(param, {}, function(response){
                    initGroupsAndUsers();
                    $scope.spAlert = new SpAlert('success', 'shared_accounts.messages.share_account');
                }, errorUnshareGroup);
            }
            
            var initGroupsAndUsers = function(){
                SharedAccountsService.getSaaspassUsersByCorporateServiceAccountId({companyId: companyId, id: account.id},{}, function(response){
                    $scope.users = response.sharedUsersList;
                    $scope.sharedGroupsList = response.sharedGroupsList;
                    $scope.unsharedGroupsList = response.unsharedGroupsList;
                    $scope.groupSelectionChange(0);
                }, errorInitGroupsAndUsers);
            }
            
            initGroupsAndUsers();


            $scope.groupSelectionChange = function(selectedGroup){ 
                console.log('selection changed: ' + selectedGroup);
                $scope.selectedGroup = selectedGroup
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/share/computer-administration-accounts-share.modal.js